import { map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';

import { JobsiteSetAction } from '../../../actions/jobsite-actions/jobsite.actions';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { Injectable } from '@angular/core';
import { getJobsiteState, OrderBuilderState } from '../../../../../reducers';
import { IJobsiteState } from '../../../reducers/jobsite-reducer/jobsite.reducer';
import { ProductsResetAction } from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/products.actions';
import { ContractsResetBalanceAction } from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/contracts.actions';
import { SlotsResetAction } from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/slots.actions';
import { ResetOrderAvailabilityAction } from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/order-availability.actions';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * An injectable behaviour which sets the jobsite for an order in the Store according
 * to the ID number passed in.
 */
@Injectable()
export class JobsiteSetCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Seeks a job-site with an ID matching the input value in the current
   * state of the Store, and - if found - sets the chosen job-site in the
   * Store to match.
   * @param value
   */
  onFieldChanged(value: any): void {
    value = parseInt(value, 10);
    this.store
      .select(getJobsiteState)
      .pipe(
        take(1),
        map((state: IJobsiteState) => {
          return _safe(() =>
            state.jobsites.find((jobsite: IShipmentLocation) => {
              return jobsite.shipmentLocationId === value;
            }),
          );
        }),
      )
      .subscribe((jobsite: IShipmentLocation) => {
        /*
         * The filter above should keep out job-sites whose ID isn't in the
         * collection at state.jobsites.
         */
        if (!!jobsite) {
          return (
            this.store.dispatch(new JobsiteSetAction(jobsite)),
            this.store.dispatch(new ProductsResetAction()),
            this.store.dispatch(new ContractsResetBalanceAction()),
            this.store.dispatch(new SlotsResetAction()),
            this.store.dispatch(new ResetOrderAvailabilityAction())
          );
        }
      });
  }
}
